import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  today: number = Date.now();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/footer/footer.component.ts